import { render, staticRenderFns } from "./Produccion.vue?vue&type=template&id=ae0488fc&scoped=true"
import script from "./Produccion.vue?vue&type=script&lang=js"
export * from "./Produccion.vue?vue&type=script&lang=js"
import style0 from "./Produccion.vue?vue&type=style&index=0&id=ae0488fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0488fc",
  null
  
)

export default component.exports